import { Auth, API } from "aws-amplify";

async function send(bot, action) {
  return API.post("prod-slippy", "/pm2-remote/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      action
    }
  });
}

export { send };
